import React from 'react';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';

export function UrlStateBadge() {
  const { toast } = useToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      toast({ description: 'URL copied — bookmark to save this view.' });
    });
  };

  const search = window.location.search;

  if (!search) return null;

  return (
    <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-muted text-muted-foreground text-xs font-mono max-w-[300px]">
      <span className="truncate">{decodeURIComponent(search)}</span>
      <Button
        variant="ghost"
        size="icon"
        className="h-5 w-5 shrink-0"
        onClick={handleCopy}
        title="Copy URL"
      >
        <Copy className="h-3 w-3" />
      </Button>
    </div>
  );
}
